import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [{
            path: '/',
            name: 'index',
            component: () =>
                import ('../views/index/index.vue')
        },
        {
            path: '/logo',
            name: 'logo',
            redirect: "/"
        },
        {
            path: '/about', //关于我们
            name: 'about',
            component: () =>
                import ('../views/about/index.vue')
        },
        {
            path: '/gpc', //石油焦
            name: 'gpc',
            component: () =>
                import ('../views/mainBusiness/gpc.vue')
        },
        {
            path: '/cpc', //煅后焦
            name: 'cpc',
            component: () =>
                import ('../views/mainBusiness/cpc.vue')
        },
        {
            path: '/besinessScope/bulkTrade', //大宗贸易
            name: 'besinessScope/bulkTrade',
            component: () =>
                import ('../views/besinessScope/bulkTrade/index.vue')
        },
        {
            path: '/besinessScope/bulkTrade/detail/:id', //大宗贸易详情
            name: 'besinessScope/bulkTrade/detail',
            component: () =>
                import ('../views/besinessScope/bulkTrade/detail.vue')
        },
        {
            path: '/besinessScope/integratedLogistics', //综合物流
            name: 'besinessScope/integratedLogistics',
            component: () =>
                import ('../views/besinessScope/integratedLogistics/index.vue')
        },
        {
            path: '/besinessScope/productionManufacturing', //生产制造
            name: 'besinessScope/productionManufacturing',
            component: () =>
                import ('../views/besinessScope/productionManufacturing/index.vue')
        },
        {
            path: '/besinessScope/industryFinanceCollaboration', //产融协同
            name: 'besinessScope/industryFinanceCollaboration',
            component: () =>
                import ('../views/besinessScope/industryFinanceCollaboration/index.vue')
        },
        {
            path: '/besinessScope/exportOfServices', //劳务输出
            name: 'besinessScope/exportOfServices',
            component: () =>
                import ('../views/besinessScope/exportOfServices/index.vue')
        },
        {
            path: '/news', //新闻
            name: 'news',
            component: () =>
                import ('../views/news/index.vue')
        },
        {
            path: '/news/detail/:id',
            name: 'news/detail',
            component: () =>
                import ('../views/news/detail.vue')
        },
        {
            path: '/socialResponsibility', //社会责任
            name: 'socialResponsibility',
            component: () =>
                import ('../views/socialResponsibility/index.vue')
        },
        {
            path: '/talentDevelopment', //人才发展
            name: 'talentDevelopment',
            component: () =>
                import ('../views/talentDevelopment/index.vue')
        },
        {
            path: '/photoAlbum', //人才发展图册
            name: 'photoAlbum',
            component: () =>
                import ('../views/talentDevelopment/photoAlbum.vue')
        },
        {
            path: '/talentRecruitment/:id', //社会招聘
            name: 'talentRecruitment',
            component: () =>
                import ('../views/talentRecruitment/index.vue')
        },
        {
            path: '/supervisionAndReporting', //监督举报
            name: 'supervisionAndReporting',
            component: () =>
                import ('../views/supervisionAndReporting/index.vue')
        },
        {
            path: '/contact', //联系我们
            name: 'contact',
            component: () =>
                import ('../views/contact/index.vue')
        },
        {
            path: '/year20', //20周年专题页
            name: 'year20',
            component: () =>
                import ('../views/year20/index.vue')
        },
    ]
    // 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}



const router = new Router({
    mode: 'hash', //history  hash
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: () => ({ x: 0, y: 0 }),
})


export default router